<template>
  <div>
    <ul class="divide-y divide-gray-200 px-4 sm:px-5" v-if="single_evidence_detail.evidences.internal_user_activities.length >0">
      <li class="py-4" v-for="(internal_activity,index) in single_evidence_detail.evidences.internal_user_activities" :key="index">
        <div class="flex">
          <div class="flex-1 space-y-1">
            <div class="flex items-center justify-between">
              <h3 class="text-sm font-medium text-gray-900 mb-0.5">Operator: {{internal_activity.operators.name}}</h3>
              <p class="text-sm text-gray-400">{{internal_activity.created_at}}</p>
            </div>
            <p class="text-sm text-gray-600"><span class="font-medium">Comment:</span> {{internal_activity.comment}}</p>
            <p class="text-sm text-gray-600"><span class="font-medium">Activity:</span> {{internal_activity.activity}}</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { siteUrl } from '../../config/base';


export default {
props :["single_evidence_detail"],
  components: {
  
  },
  data() {
    return {
   
    };
  },
  created(){
   
  },
  methods: {
   
  }
};
</script>

<style scoped>
</style>
